import { useEffect, useState } from "react"
import { useQuery } from "react-query"
import "./ThemeTwo.scss"
import ThemeCvDto from "../../../../api/models/cvTheme"
import cvskillService from "../../../../api/services/cvskillService"
import { useCvSkill } from "../../../../hooks/useCvSkill"
import HeaderCvTwo from "./headerTwo/headerCvTwo"
import AtoutsCvTwo from "./atoutsTwo/atoutsCvTwo"
import AdjectifsCvTwo from "./adjectifsTwo/adjectifsCvTwo"
import InteretsCvTwo from "./interetsTwo/interetsCvTwo"

interface ThemeTwoProps {
	isPhoto?: boolean
	theme?: ThemeCvDto | null
}

function ThemeTwo({ isPhoto, theme }: ThemeTwoProps) {
	const { cvSkill, user, loading, error: hookError } = useCvSkill()

	useEffect(() => {
		console.log("[1][themeTwo] user (from useCvSkill) =", user)
	}, [user])

	// Récupération de la photo
	const { data: photoData } = useQuery(
		["photo", cvSkill?.id],
		() => (cvSkill?.id ? cvskillService.getPhoto(cvSkill.id) : null),
		{ enabled: !!cvSkill?.id },
	)

	const [photoUrl, setPhotoUrl] = useState<string | null>(null)

	useEffect(() => {
		if (!photoData) {
			setPhotoUrl(null)
			return undefined
		}
		const url = URL.createObjectURL(
			new Blob([photoData], { type: "image/jpeg" }),
		)
		setPhotoUrl(url)
		return () => URL.revokeObjectURL(url)
	}, [photoData])

	if (loading) {
		return (
			<div
				className="theme-two-container"
				style={{ fontFamily: theme?.fontFamily }}
			>
				<p>Chargement des informations...</p>
			</div>
		)
	}

	if (hookError) {
		return (
			<div
				className="theme-two-container"
				style={{ fontFamily: theme?.fontFamily }}
			>
				<p style={{ color: "red" }}>{hookError}</p>
			</div>
		)
	}

	if (!user || !cvSkill) {
		return (
			<div
				className="theme-two-container"
				style={{ fontFamily: theme?.fontFamily }}
			>
				<p style={{ color: "red" }}>
					Aucune donnée disponible pour ce CV
				</p>
			</div>
		)
	}

	return (
		<div
			className="theme-two-container"
			style={{ fontFamily: theme?.fontFamily }}
		>
			<HeaderCvTwo
				theme={theme}
				user={user}
				isPhoto={isPhoto}
				photoUrl={photoUrl}
			/>
			<AtoutsCvTwo theme={theme} cvSkill={cvSkill} />
			<div className="bottom-row-two">
				<AdjectifsCvTwo theme={theme} cvSkill={cvSkill} />
				<InteretsCvTwo theme={theme} cvSkill={cvSkill} />
			</div>
		</div>
	)
}

export default ThemeTwo
